import React, { useEffect } from "react";
import Main from "../components/AboutUs/Main";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);
  return (
    <div>
      <Main />
    </div>
  );
};

export default AboutUs;
